import { render, staticRenderFns } from "./InvoiceExpressInfo.vue?vue&type=template&id=3324170d&scoped=true&"
import script from "./InvoiceExpressInfo.vue?vue&type=script&lang=js&"
export * from "./InvoiceExpressInfo.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceExpressInfo.vue?vue&type=style&index=0&id=3324170d&scoped=scoped&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3324170d",
  null
  
)

export default component.exports